// Module
var code = "<div> <div id=\"V-9DF30B0E-45DC-4521-97E6-04CC3610398D\" data-b-event-click=\"{Binding click}\" data-b-class-selected=\"{Binding isselected}\" class=\"component-toggle-button\"> {Binding content} </div> </div> ";
// Exports
export default code;